import React from 'react';
import { MapPin, Github, Twitter, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy text-parchment pt-20 pb-10 relative overflow-hidden" data-id="element-33">
      {/* Decorative Topography Overlay */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-34">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-35">
          <path d="M0,100 Q50,50 100,100" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-36" />
          <path d="M0,80 Q50,30 100,80" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-37" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-38">
        <div className="grid md:grid-cols-4 gap-12 mb-16" data-id="element-39">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-40">
            <div className="flex items-center space-x-2 mb-4" data-id="element-41">
              <MapPin className="h-6 w-6 text-gold" data-id="element-42" />
              <span className="text-2xl font-serif font-bold text-parchment" data-id="element-43">
                Maplekeep
              </span>
            </div>
            <p className="text-parchment/60 font-sans mb-6" data-id="element-44">
              Cartography for the curious. Mapping the world one story at a
              time.
            </p>
            <div className="flex space-x-4" data-id="element-45">
              <a href="#" className="text-parchment/60 hover:text-gold transition-colors" data-id="element-46">
                <Twitter size={20} data-id="element-47" />
              </a>
              <a href="#" className="text-parchment/60 hover:text-gold transition-colors" data-id="element-48">
                <Instagram size={20} data-id="element-49" />
              </a>
              <a href="#" className="text-parchment/60 hover:text-gold transition-colors" data-id="element-50">
                <Github size={20} data-id="element-51" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-52">
            <h4 className="font-serif font-bold text-lg mb-6 text-gold" data-id="element-53">
              Product
            </h4>
            <ul className="space-y-3 text-parchment/60" data-id="element-54">
              <li data-id="element-55">
                <a href="#" className="hover:text-parchment transition-colors" data-id="element-56">
                  Pinboard
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="hover:text-parchment transition-colors" data-id="element-58">
                  Fieldbook
                </a>
              </li>
              <li data-id="element-59">
                <a href="#" className="hover:text-parchment transition-colors" data-id="element-60">
                  Terrain Compass
                </a>
              </li>
              <li data-id="element-61">
                <a href="#" className="hover:text-parchment transition-colors" data-id="element-62">
                  Meridian Tools
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-63">
            <h4 className="font-serif font-bold text-lg mb-6 text-gold" data-id="element-64">
              Company
            </h4>
            <ul className="space-y-3 text-parchment/60" data-id="element-65">
              <li data-id="element-66">
                <a href="#" className="hover:text-parchment transition-colors" data-id="element-67">
                  About
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="hover:text-parchment transition-colors" data-id="element-69">
                  Journal
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="hover:text-parchment transition-colors" data-id="element-71">
                  Careers
                </a>
              </li>
              <li data-id="element-72">
                <a href="#" className="hover:text-parchment transition-colors" data-id="element-73">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-74">
            <h4 className="font-serif font-bold text-lg mb-6 text-gold" data-id="element-75">
              Legal
            </h4>
            <ul className="space-y-3 text-parchment/60" data-id="element-76">
              <li data-id="element-77">
                <a href="#" className="hover:text-parchment transition-colors" data-id="element-78">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-79">
                <a href="#" className="hover:text-parchment transition-colors" data-id="element-80">
                  Terms of Service
                </a>
              </li>
              <li className="pt-4 text-sm" data-id="element-81">
                Limassol, Cyprus
                <br data-id="element-82" />
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-parchment/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-parchment/40" data-id="element-83">
          <p data-id="element-84">© 2026 Maplekeep. All rights reserved.</p>
          <p className="mt-2 md:mt-0 font-serif italic" data-id="element-85">
            Designed for explorers.
          </p>
        </div>
      </div>
    </footer>;
}